import { modalRoute } from '@/router/helpers/modalRoute'

export const cryptoRoutes = [
  {
    path: 'crypto',
    name: 'Crypto',
    component: () => import('@/components/crypto/Index.vue'),
    children: [
      modalRoute(
        'buy',
        'BuyCrypto',
        () => import('@/components/crypto/modals/Buy.vue'),
        {
          meta: {
            permissions: ['cryptoBuy'],
          },
        },
      ),
      modalRoute(
        'sell',
        'SellCrypto',
        () => import('@/components/crypto/modals/sell/SellModal.vue'),
        {
          meta: {
            permissions: ['cryptoSell'],
          },
        },
      ),
      modalRoute(
        'verify',
        'VerifyCrypto',
        () => import('@/components/crypto/modals/VerifyCrypto.vue'),
      ),
      modalRoute(
        'view/:cryptoId',
        'CryptoDetails',
        () => import('@/components/crypto/modals/CryptoDetails.vue'),
      ),
      modalRoute(
        'wallet/:walletUuid/details',
        'CryptoWalletDetails',
        () => import('@/components/wallets/modals/details/WalletDetails.vue'),
      ),
    ],
    meta: {
      permissions: ['cryptoBuy', 'cryptoSell'],
      permissionStrategy: 'some',
    },
  },
]
